import {SimplePage} from "../../elements/Pages";
import React from "react";

import {useQuery} from "@tanstack/react-query";
import ListViewTable from "../../elements/tables/ListViewTable";
import {alumniStaffApi} from "../../../api/staff";

const columns = [
    {
        accessorKey: 'full_name',
        id: 'full_name',
        header: 'Name',
        enableColumnFilter: false,
        sortingFn: "lastNameSorting",
    },
    {
        accessorKey: "email",
        id: "email",
        header: "Email",
        enableColumnFilter: false,
    },
    {
        accessorKey: "previous_roles",
        id: "previous_roles",
        header: "Tätigkeit",
        enableColumnFilter: false
    }
];

export default function AlumniStaffList() {

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["alumni_staff"],
        () => alumniStaffApi('get'),
        {refetchInterval: 1000 * 60 * 60}
    )

    function getRowLink(row) {
        return `/alumni-staff/${row.original.id}`;
    }

    if (!data) return <></>
    return (
        <SimplePage>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            Ehemalige MitarbeiterInnen
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    getRowLink={getRowLink}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
